export default __webpack_public_path__ + "static/media/9318694-removebg-preview.1ecdb17f.png";